import React from 'react';

export const HALF_WIDTH = { upper: 26, lower: 27 };

export const NAME = { upper: 'Aql tishi', lower: 'Aql tishi' };

/*
 * Upper third molar: the most variable tooth. The crown is short and heart
 * shaped with poorly defined cusps, and the three roots are usually fused into
 * one short conical mass — drawn here as a single tapering root marked by the
 * grooves left by the fusion.
 */
const UPPER_OUTLINE = `M 30 48
    C 26.6 56 24.4 62.4 24 69
    C 23.6 76.4 26 83.4 29.6 87.4
    Q 31.6 89.6 34.4 91.4
    L 37.6 93.8
    Q 39.8 95.2 41.8 93.2
    L 46.4 88.8
    Q 47.6 87.8 48.8 89
    L 53.6 93.4
    Q 55.8 95 57.8 93.2
    L 64.4 87.6
    C 68.2 84 70.4 77 70 69.4
    C 69.6 62.4 67.4 55.4 64.6 48
    C 65.4 42 65.8 35 65 28.4
    C 64.2 22 62.4 16.4 60 13.6
    C 57.6 10.8 53.4 10 50 11.6
    C 46.4 13.2 43 18 40.4 24.4
    C 37.6 31.4 36 39 35.2 44
    C 34.8 46 32.6 46.6 30 48 Z`;

const UPPER_CERVICAL = 'M 30 48 C 38 41.4 58.6 41.4 64.6 48';

const UPPER_DETAILS = [
    'M 47.6 88.6 C 47.2 82 47 75.4 47.6 69',
    'M 39.4 92.6 C 39.8 86 40 80 39.6 74.4',
    'M 55.6 92.4 C 56 86 56.2 80 55.8 74.4',
    /* Grooves left where the three roots are fused. */
    'M 44.6 44 C 44.2 36 44.4 27 46 20',
    'M 56 43.4 C 56.6 36 56.6 28 55.4 21.4',
];

/*
 * Lower third molar: a rounded, slightly shrunken four-cusp crown with blunt
 * cusps, and fused roots that curve distally.
 */
const LOWER_OUTLINE = `M 31 52
    C 27.8 43 25 34.4 24.4 26.4
    C 24 19.4 26.2 12.6 30 9
    Q 32.6 6.6 36.2 7.4
    L 40 6.2
    Q 42.2 5.4 43.6 7.4
    L 49.4 13
    Q 50.8 14.2 52.2 12.8
    L 58.4 7.4
    Q 60.6 5.4 62.8 7.4
    L 66.2 8.4
    Q 69.4 9.4 71.4 12.4
    C 73.8 16 74.6 22.4 73.6 29.4
    C 72.4 37.4 69.6 45 67 52
    C 68.6 59.4 69.4 67.4 68.6 75
    C 67.8 82.4 65.6 88.4 62.4 91.4
    Q 58.4 95 53.6 93.6
    C 49.8 92.4 46.4 88.4 43.4 82.4
    C 40.2 76 37.4 68 35.4 60.6
    C 34.6 57.4 33.4 54.6 31 52 Z`;

const LOWER_CERVICAL = 'M 31 52 C 39 57.6 60 57.6 67 52';

const LOWER_DETAILS = [
    'M 50.8 13.4 C 50.4 20.4 50.2 28 50.8 35.4',
    'M 39.8 7.6 C 40.2 14.4 40.4 21 40 27',
    'M 61 8 C 61.4 14.6 61.6 21.2 61.2 27.4',
    /* Fusion grooves of the distally curving root mass. */
    'M 45.4 60 C 45.8 69 46.6 78 48.4 86',
    'M 57 59.4 C 57.4 67.4 57.4 75.4 56 83',
];

export default function ThirdMolar({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
